import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-odl-form',
  templateUrl: './dynamic-odl-form.component.html',
  styleUrls: ['./dynamic-odl-form.component.scss']
})
export class DynamicOdlFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
